







































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Section } from "@/common/interface";
import store from "@/store";
import { Getter, Action } from "vuex-class";
import DashLine from "@/components/common/edit/DashLine.vue";
import CourseIntro from "./CourseIntro.vue";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import getUrlParam from "@/common/utils/getUrlParam";
import { resolveBoundaryValue } from '@/common/utils/format';

@Component({
  components: {
    "activity-label": ActivityLabel,
    "course-intro": CourseIntro,
    "dash-line": DashLine,
  },
})
export default class ActivityLimit extends Vue {
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("section") section: any;
  @Getter("distributeTypeParameter") distributeTypeParameter!: Object;
  @Action("changeSectionInfo") changeSectionInfo!: Function;

  oldCourseOriginPrice: number = this.$store.state.section.courseOriginPrice;
  oldCourseRushPrice: number = this.$store.state.section.courseRushPrice;
  oldValue: number = this.$store.state.section.limitBuyerNum;

  type: string = getUrlParam("type") as string;

  @Watch("section.limitBuyerNum")
  changeLimitBuyerNum(newVal: any) {
    const oldValue = this.$store.state.distributeTypeParameter.limitBuyerNum;
    if (this.type === "reEdit" &&  Number(newVal) < oldValue) {
      store.dispatch("changeSubtractLimitBuyerNum",true)
    }else {
      store.dispatch("changeSubtractLimitBuyerNum",false)
    }
  }

  get disabled() {
    return getUrlParam('type') === 'reEdit';
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    const _value = resolveBoundaryValue(value, hasDecimal);
    this.changeSectionInfo({ type, value: _value });
  }
}
